// extracted by mini-css-extract-plugin
export default {"btop":"_8ab5dfa697 _0ec69be41b _9dd75f53e6","icon":"c778995987 _6cff2bfe0a","btoppink":"da2490d525 a0434f1100"};